import React from 'react';
import { Box } from '@mui/material';
import { FormattedMessage, FormattedDate } from 'react-intl';

import { Typography } from '@ocx/ui';
import { LoyaltyCurrencyIcon, useLoyaltyCurrencyFormat } from '@ocx/feat-loyalty-currency';
import { SizingMultiplier } from '@ocx-app/theme/constants';
import type { PointExpirationScheduleFragment } from '@ocx/graphql';

import { ExpirationIconBox } from './point-expiration-icon-box.component';
import { pointExpirationScheduleMessages } from '../point-expiration-schedule.messages';

export type PointExpirationListItemProps = {
  item: PointExpirationScheduleFragment;
  isExpiringSoon: boolean;
};

const ICON_WRAPPER = 20;
const LIST_ITEM_HEIGHT = 56;

export const PointExpirationListItem = ({ item, isExpiringSoon }: PointExpirationListItemProps) => {
  const format = useLoyaltyCurrencyFormat();

  return (
    <Box display="flex" p={SizingMultiplier.md} minHeight={LIST_ITEM_HEIGHT} alignItems="stretch">
      <ExpirationIconBox variant={isExpiringSoon ? 'warning' : 'normal'} />

      <Box display="flex" flex={1} textAlign="left" flexDirection="column" justifyContent="space-between">
        <Typography variant="subtitle1">
          {isExpiringSoon ? (
            <FormattedMessage {...pointExpirationScheduleMessages['point-expiration-schedule:expiring-soon']} />
          ) : (
            <FormattedMessage {...pointExpirationScheduleMessages['point-expiration-schedule:points-expiring']} />
          )}
        </Typography>
        <Typography variant="body2" component="span" color="text.disabled">
          <FormattedDate value={new Date(item.date)} year="numeric" month="short" day="numeric" />
        </Typography>
      </Box>

      <Box display="flex" textAlign="right" alignItems="center">
        <Typography variant="subtitle1" sx={{ mr: 0.5 }}>
          {format(-item.points)}
        </Typography>
        <Box width={ICON_WRAPPER} height={ICON_WRAPPER} display="flex" alignItems="center" justifyContent="center">
          <LoyaltyCurrencyIcon variant="single" size="small" />
        </Box>
      </Box>
    </Box>
  );
};
